import { loadLanguageAsync, i18n } from '@/i18n'
import { graphqlManageError } from '@/helpers'
import each from 'lodash/each'
import Config from 'config'
import Graphql from '@/services/Graphql'
import HttpProvider from '@/services/HttpProvider'
import urlResolver from 'theme/services/graphQlquery/urlResolve.js'

export function changeStore ({ vm, store, router, boutique, isOnlineStore }) {
  // store: App $store
  // router: App $router
  // boutique: boutiuqe selected
  // isOnlineStore: Boolean -> if selected boutiue is online
  store.commit('ui/showLoader')
  // set new code
  // store.commit('userAdmin/setOnlineMode', isOnlineStore)
  let lang = boutique.code ? boutique.code.replace('-', '_').toLowerCase() : process.env.VUE_APP_STOREVIEWCODE
  // create location www.doma.in/it_it
  let location = `${process.env.VUE_APP_BASE_PATH}/${lang}`
  // set url code -> it_it
  store.commit('ui/urlCode', lang)
  // set store_view_code -> it_it
  store.commit('ui/setStoreViewCode', lang)
  // call store config using full url
  const onRouteReplace = () => {
    vm.$root.$forceUpdate()
    store.commit('ui/setRouterRefresh', false)
  }
  return store.dispatch('storeConfig/load', { fullPath: location })
    .then(() => {
      // set new language
      const ajaxLanguage = loadLanguageAsync(i18n.locale, store.state.ui.storeViewCode, store.state.ui.locale).then(messages => {
        store.commit('ui/messagesLocale', messages)
      })
      // set menu to empty array
      store.commit('ui/saveMenu', [])
      return Promise.all([
        ajaxLanguage,
        store.dispatch('ui/loadMenu'), // load new menu
        store.dispatch('userAdmin/init'), // init user again
        store.dispatch('cart/init') // init cart
      ])
        .then(() => {
          // at the end
          // set new params to url
          return new Promise(resolve => {
            store.commit('ui/setRouterRefresh', true)
            router.replace({ params: { lang } }, function () {
              // onComplete
              onRouteReplace()
              return resolve(true)
            }, function () {
              // onAbort -> if has the same params
              onRouteReplace()
              return resolve(true)
            })
          })
        })
        .finally(() => {
          // hide global loader
          store.commit('ui/hideLoader')
        })
    })
}

export function formatAddress (addrr, { email = '', formatText = false }) {
  if (formatText) {
    return `
    ${addrr.firstname} ${addrr.lastname}, ${email || ''} ${addrr.telephone}<br>
    ${addrr.street.join(' ')} ${addrr.country_id}<br>
    ${addrr.city} ${addrr.postcode}<br>
    ${addrr.city}
  `
  } else {
    if (addrr.firstname && addrr.lastname) {
      return `${addrr.firstname} ${addrr.lastname}, ${email || ''} ${addrr.telephone}, ${addrr.street.join(' ')}, ${addrr.city}, ${addrr.region.region_code || ''} ${addrr.postcode} ${addrr.country_id}`
    } else {
      return null
    }
  }
}

/* prevent scrolling on ios */
let scrollPosition = 0

export function enablePreventScrollingSafari () {
  const $body = document.querySelector('body')
  scrollPosition = window.pageYOffset
  $body.style.overflow = 'hidden'
  $body.style.position = 'fixed'
  $body.style.top = `-${scrollPosition}px`
  $body.style.width = '100%'
}

export function disablePreventScrollingSafari () {
  const $body = document.querySelector('body')
  $body.style.removeProperty('overflow')
  $body.style.removeProperty('position')
  $body.style.removeProperty('top')
  $body.style.removeProperty('width')
  window.scrollTo(0, scrollPosition)
}

export function getCookie (cookieName) {
  if (process.client) {
    if (global.$cookies) {
      return global.$cookies.get(cookieName) || null
    }
  } else {
    // server side
    if (global.ctx && global.ctx.cookie) {
      return global.ctx.cookie[cookieName] || null
    }
  }
  return null
}

export function getConfigurableOptMap (configurableOptions) {
  let map = {}
  let options = configurableOptions
  if (options) {
    options.forEach(confOpt => {
      map[confOpt.attribute_id] = confOpt.attribute_code
    })
  }
  return map
}

export function getVariantByFilter (skip, filterActive, variants, configurableOptions) {
  // let exitForm = false
  let options = []
  let skipDuplicate = {}
  let filter = filterActive
  let confMap = getConfigurableOptMap(configurableOptions)
  let exitFor
  let attributeMap
  if (variants) {
    for (let i in variants) {
      exitFor = false
      attributeMap = {}
      if (variants[i].attributes.length) {
        each(variants[i].attributes, item => {
          attributeMap[item.code] = item
        })
        if (!skipDuplicate[attributeMap[skip]]) {
          for (let key in filter) {
            if (confMap[key] !== skip) {
              if (attributeMap[confMap[key]].value_index !== filter[key]) {
                exitFor = true
                break
              }
            }
          }
          if (!exitFor) {
            options.push({
              label: attributeMap[skip].label,
              value: attributeMap[skip].value_index,
              is_pre_order: variants[i].product.is_preorder,
              quantity: variants[i].product.quantity,
              in_stock: variants[i].product.stock_status === 'IN_STOCK'
            })
            skipDuplicate[attributeMap[skip].value_index] = true
          }
        }
      }
    }
  }
  return options
}

// override -> src/store/modules/checkout/defaultValues.js
export const DefaultAddress = {
  firstname: '',
  lastname: '',
  street: [],
  city: '',
  company: '',
  fax: '',
  region: { region: '', region_code: '', region_id: 0 },
  postcode: '',
  country_id: '',
  telephone: '',
  default_shipping: false,
  default_billing: false,
  useotheraddress: false
}

export const DefaultShippingMethod = {
  shippingMethod: 'ClickAndCollect',
  shippingMethods: [
    {
      method_code: 'ClickAndCollect',
      method_title: 'ClickAndCollect'
    }
  ]
}

export const DefaultShipping = {
  ...DefaultAddress,
  shippingMethod: DefaultShippingMethod,
  shippingMethodAdditional: {}
}

export function writeOperationLog (operationLog, agentId) {
  const url = Config.API.logs.operationLog
  const headers = {
    'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`,
    'X-Requested-With': 'XMLHttpRequest'
  }
  let params = {
    operationLog,
    agent_id: agentId
  }
  return HttpProvider.put(url, params, headers)
}

export function urlResolve (categoryId, ctx) {
  // cached call
  return Graphql.genericCallCash({
    token: ctx.store.state.user.token,
    storeViewCode: ctx.store.state.ui.storeViewCode,
    useInlineQuery: urlResolver,
    variables: { categoryId }
  })
    .then(resp => {
      if (graphqlManageError(resp)) {
        // eslint-disable-next-line
        throw { body: { result: graphqlManageError(resp) } }
      }
      if (resp.data && resp.data.urlResolver === null) {
        // eslint-disable-next-line
        throw { body: { result: 'no results', url: url } }
      }
      return resp && resp.data ? resp.data.urlResolver : {}
    })
    .catch(err => {
      throw err
    })
}

export function invalidateCartSession ($store, error) {
  // invalidate session of cart
  // only if error is 401 - 403
  let status = error.status || error.response.status
  if (status === 401 || status === 403) {
    return $store.dispatch('cart/empty')
      .finally(() => {
        return error
      })
  }
}

// coin start with 00
// add 00 on string start if code is below 9 digit
export function fillToPad (value, numToPad) {
  const regex = /^[-\d]+$/
  if (value.match(regex)) {
    value = value.split('-')[0]
    let stringFillPad = ''
    for (let i = 0; i < numToPad; i++) {
      stringFillPad += '0'
    }
    let zeros = stringFillPad.substring(0, stringFillPad.length - value.toString().length)
    return (zeros + value)
  } else {
    return value
  }
}

export function latestValidCheckoutStep ($store) {
  /**
   * step 1 fake-choice (get from cookie) -> 0
   *
   * step 2 email and coin card -> 1
   *
   * step 3 shipping && billing -> 2
   *
   * step 4 shipping method -> 3
   *
   * step 5 is last, no check needed -> 4
   */
  const $cookie = global.$cookies
  let lastDeliveryChoice = $cookie.get('latest-delivery-choice')
  let clickAndCollectStore = $cookie.get('pickup-store-code')
  let isClickAndCollectValid = (lastDeliveryChoice === 'ClickAndCollect' && clickAndCollectStore)
  if (!lastDeliveryChoice && !isClickAndCollectValid) {
    return 0
  } else if (!$store.getters['checkout/email']) {
    return 1
  } else if (!($store.getters['checkout/hasBillingAddress'] && $store.getters['checkout/hasShippingAddress'])) {
    return 2
  } else if (!$store.getters['checkout/hasShippingMethod']) {
    return 3
  } else {
    return 4
  }
}

export function replaceFromString (str, strToReplace, newText = '') {
  return str.replace(strToReplace, newText)
}

export function replaceCoinCardPrefix (card) {
  return replaceFromString(card, /90000/g)
}
